import sortBy from 'lodash/sortBy';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'shared/interface';
import { CategoryDataInterface } from '../../interface';
import { PopularSkeleton } from '../loader/sideBarSkeleton/PopularSkeleton';
import NavigationPopularNav from './navigationPopularNav';

interface NavigationProps {
	className?: string;
	title?: string;
}

export const NavigationPopular = ({ title = '', className = '' }: NavigationProps) => {
	const popular = useSelector<State, Record<number, CategoryDataInterface>>((state) => state.categories.popular);
	const menu: any = useMemo(() => {
		const orderedPopular = sortBy(popular, ['sortOrder']);
		return orderedPopular;
	}, [popular]);

	return menu.length > 0 ? <NavigationPopularNav className={className} title={title} menu={menu} /> : <PopularSkeleton />;
};

export default NavigationPopular;
